<template>
    <div>
        <NavigationReceiver currentQuestion="3"></NavigationReceiver>
        <section class="pt-5">
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-3">
                        <div class="alert alert-warning d-flex mb-2" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Kijk niet langer dan een week terug en vul dan de vragen zo goed mogelijk in.</span>
                        </div>
                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Activiteiten die u wél als zwaar ervaart en die niet in de lijst staan, kunt u aan het eind toevoegen.</span>
                        </div>
                    </div>
                    <div class="col-xl-6 px-5 text-center">
                        <div class="row justify-content-center mb-4">
                            <div class="col-xl-3 col-4">
                                <img src="/img/questions/vraag3.png" class="img-fluid">
                            </div>
                        </div>
                        <h2 class="mb-4">{{ QuestionRepository.getQuestionValueById(3.1) }}</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12 col-12 text-center">
                                <RadioField :error="error" :options="[{
                                        value: 'ja',
                                        title: 'Ja'
                                    }, {
                                        value: 'nee',
                                        title: 'Nee'
                                    }]" id="3.1"></RadioField>
                                <transition name="fade-in-up">
                                    <div v-if="showFields()">
                                        <TextareaField :placeholder="QuestionRepository.getQuestionValueById(3.2)" id="3.2" :title="QuestionRepository.getQuestionValueById(3.2)"></TextareaField>
                                        <SelectField :options="[{
                                            value: 'Minder dan 25 kg',
                                            title: 'Minder dan 25 kg'
                                        }, {
                                            value: 'Meer dan 25 kg',
                                            title: 'Meer dan 25 kg'
                                        }]" id="3.3" :title="QuestionRepository.getQuestionValueById(3.3)"></SelectField>
                                    </div>
                                </transition>
                                <div class="alert alert-warning text-start mb-4">
                                    <span class="sub italic text-start">* let op, het gaat erom hoe hard je moet duwen, niet hoe zwaar het object is wat je duwt. <br>Bekijk onderstaande video voor meer uitleg.</span>
                                </div>
                                <div class="ratio ratio-16x9 mb-4">
                                    <iframe src="https://www.youtube.com/embed/QRlF_mMpmTo?rel=0" class="rounded" title="YouTube video" allowfullscreen></iframe>
                                </div>
                                <div class="text-center">
                                    <button @click="nextStep($event)" class="btn btn-primary mb-3">Volgende vraag</button>
                                    <br>
                                    <button class="btn-previous-question" @click="previousStep($event)">Vorige vraag</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RadioField from "../../../includes/RadioField";
import TextareaField from "../../../includes/TextareaField";
import SelectField from "../../../includes/SelectField";
import RecipientService from "../../../../services/RecipientService";
import defaultMethods from "./defaultMethods";
import defaultData from "./defaultData";

export default {
    name:       'StepThree',
    components: { SelectField, TextareaField, RadioField, NavigationReceiver },
    data() {
        return {
            ... defaultData,
            showFieldsOn:     '3.1',
            nextStepSlug:     'stap-4',
            previousStepSlug: 'stap-2',
            error:            false
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next, true);
    },
    methods: {
        ... defaultMethods
    }
}
</script>
